import React from 'react';
import { get } from './objectHelper';
import { CURRENCY_FALLBACK } from '../config';

/**
* Convert ISO currency code to currency sign
*
* @param {string} ISOCurrencyCode - Iso currency code
*/
export const ISOCurrencyCovert = (ISOCurrencyCode) => {
  switch (ISOCurrencyCode) {
    case "GBP": return <span>&#163;</span>;
    case "AUD": return <span>&#36;</span>;
    case "NZD": return <span>&#36;</span>;
    case "USD": return <span>&#36;</span>;
    case "CAD": return <span>&#36;</span>;
    case "ZAR": return <span>R</span>;
    case "EUR": return <span>&#8364;</span>;
    default: return <span>&#36;</span>;
  }
}


/**
* Helper for currency data
*
* @param {object} agent - the agent object
*/
export function currencyData(agent){
  return {
    currency_sign: get(['currency', 'currency_sign'], agent, CURRENCY_FALLBACK.currency_sign),
    iso_currency_code: get(['currency', 'iso_currency_code'], agent, CURRENCY_FALLBACK.iso_currency_code)
  }
}